// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false,
      	filterTreeMobileStyle: 'style1',
      	paginationType: 'load_more',
      	showVariantImageBasedOnSelectedFilter: 'pf_opt_color',
      	showPlaceholderProductList: true,
        placeholderProductPerRow: 4,
        placeholderProductGridItemClass: 'product-item',
  	}
};

var AllColors = {};
var AllColorsMerged = {};



(function() {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		firstVariant = {},
		boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
		boostPFSRangeWidths = [200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200];

	BoostPFS.inject(this);

    function getRandomIntInclusive(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    // Collection by Color pre-selected Color Item
    if (!Utils.getParam('pf_opt_color') && boostPFSThemeConfig.custom.collection_color  && boostPFSThemeConfig.custom.collection_color != '') {
      var queryParams = new URLSearchParams(window.location.search);
      for (var i = 0; i < boostPFSThemeConfig.custom.collection_color.length; i++) {
         queryParams.append("pf_opt_color", boostPFSThemeConfig.custom.collection_color[i]);
      }
      history.replaceState(null, null, "?"+queryParams.toString());
    }

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
        data['hide_product'] = false;
        var available_colors = [];
      	for (var i = 0; i < data['variants'].length; i++) {
          
          let merged_color = data['variants'][i].option1;
          let size = data['variants'][i].option2;
          let fabric = data['variants'][i].option3;
          data['variants'][i]['mergedColor'] = merged_color;
          let originalColor = '';
          if(data['variants'][i].title.indexOf('/') !== -1) {
            originalColor = data['variants'][i].title
                    .replace(' / ' + size, '')
                    .replace(' / ' + fabric, '')
                    .trim();
            data['variants'][i]['originalColor'] = originalColor;
          } else{
            originalColor = data['variants'][i].title;
            data['variants'][i]['originalColor'] = originalColor;
          }
          if(data.split_product && data.variant_id == data['variants'][i].id && !data.splitColor ){
            data.splitColor = originalColor;
          }
          available_colors.push(originalColor);
          AllColors[merged_color] = originalColor;
          AllColorsMerged[originalColor] = merged_color;
		}

        if(data.split_product && data.variant_id){
          // console.log(data);
          // console.log(data.title);
          available_colors = [];
          var splitColor = data.splitColor;
          data['variants'] = data.variants.filter(function(e) {
            if (e.originalColor == splitColor){
                available_colors.push(e.originalColor);
            	return true;
            }
          });
          data['options_with_values'][0].values = data.options_with_values[0].values.filter(function(e) {
            if (e.title == splitColor){
            	return true;
            }
          });
        }

        if(!Utils.getParam('pf_opt_color') && boostPFSThemeConfig.custom.hide_sale_variants && (data.compare_at_price || data.compare_at_price_max)){
            if(data.split_product && data.variant_id){
              data['hide_product'] = true;
            } else {
              onSale = false;
              available_colors = [];
              data['variants'] = data.variants.filter(function(e) {
                if (!e.compare_at_price || e.compare_at_price <= e.price){
                    available_colors.push(e.originalColor);
                	return true;
                }
              });
            }
        }

        
        available_colors = [...new Set(available_colors)];
        if(available_colors.length >=1){
          data['available_colors'] = available_colors;
        } else{
          data['hide_product'] = true;
        }
      
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
                if (Globals.queryParams.hasOwnProperty('pf_opt_color')) {
                  var arrColor = Globals.queryParams['pf_opt_color'];
                  if (data['variants'][i].available && arrColor.includes(data['variants'][i].option_color)){
                      firstVariant = data['variants'][i];
                      data['firstVariant'] = firstVariant.id;
                      data['activeColor'] = data['variants'][i].originalColor;
                      data['activeMergedColor'] = data['variants'][i].option_color;
                      if(data.split_product && data.variant_id){
                         data.variant_id = firstVariant.id;
                      }
                      break;
                  }
                } else {
                  if (data['variants'][i].available) {
                      firstVariant = data['variants'][i];
                      data['firstVariant'] = firstVariant.id;
                      data['activeColor'] = data['variants'][i].originalColor;
                      data['activeMergedColor'] = data['variants'][i].option_color;
                      if(data.split_product && data.variant_id){
                         data.variant_id = firstVariant.id;
                      }
                      break;
                  }
                }
			}
		}
        
        // console.log(data);
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
    
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index) {
		if (!data) data = this.data;
		if (!index) index = this.index;
        
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
        // console.log(data);
      	// Get Template
		  var itemHtml = '';
          if (!data.hide_product){
		  if (boostPFSThemeConfig.custom.hasOwnProperty('tiles') && boostPFSThemeConfig.custom.tiles !== null && Globals.queryParams.page == 1 && Utils.checkExistFilterOptionParam() == false) {
			  for (var i = 0; i < boostPFSThemeConfig.custom.tiles.position.length; i++) {
                let promo = boostPFSThemeConfig.custom.tiles;
                let positions = promo.position[i].split(',');
                let position = positions[0];
                
                if (window.innerWidth < 1200 && positions[1]){
                	position = positions[1];
                }
                if (window.innerWidth < 742 && positions[2]){
                	position = positions[2];
                }
                position = parseInt(position);
                
                let type = promo.type ? promo.type[i] : "";
                let align = promo.align ? promo.align[i]  : "";
                let color = promo.color ? promo.color[i] : "#fff";
                let background = promo.background ? promo.background[i] : "";
                let title = promo.title ? promo.title[i] : "";
                let content = promo.content ? promo.content[i] : "";
                let button = promo.button ? promo.button[i] : "";
                let link = promo.link ? promo.link[i] : "";
                let scheduler = promo.scheduler ? promo.scheduler[i] ? true : false : false;
                let start_day = promo.start_day ? promo.start_day[i] : false;
                let end_day = promo.end_day ? promo.end_day[i] : false;
                let type_class = '';
                let today = new Date().toISOString().slice(0, 10);
                let status = false;
                
                if (start_day && start_day<= today){
                	status = true;
                } else {
                	status = false;
                }
                if (end_day && end_day < today){
                	status = false;
                }
                
                
                
                if (boostPFSAppConfig.general.hasOwnProperty('current_locale') && boostPFSAppConfig.general.current_locale == 'fr') {
                	title = promo.title_fr ? promo.title_fr[i] : "";
                    content = promo.content_fr ? promo.content_fr[i] : "";
                    button = promo.button_fr ? promo.button_fr[i] : "";
                  	link = promo.link_fr ? promo.link_fr[i] : "";
                    if (promo.background_fr && promo.background_fr[i] != ''){
						background = promo.background_fr[i];
                    }
                }
                if (type && type == '2/4'){
                  type_class = 'big';
                }
                
				  if (index == position - 1 ) {
                    if(!scheduler || status){
                    	itemHtml += '<product-item class="product-item grid-item grid-tile '+type_class+'" reveal>';
                        itemHtml += '<div class="grid-item__media">'+ buildPromoMediaBG(background,title) + '</div>';
                        itemHtml += '<a href="' + link + '" title="' + title + '" class="grid-item__tile-inner '+ align +'" style="color: ' + color + ';" >';
                        itemHtml += '<div>';
                        if (title != ''){
                            itemHtml += '<p class="heading h3 tile-heading">' + title + '</p>';
                        }
                        itemHtml += '</div>';
                        itemHtml += '<div>';
                          itemHtml += '<p class="heading h5 tile-para">' + content + '</p>';
                        if (button != ''){
                          itemHtml += '<span class="button button--outline" style="color: ' + color + '; border: 1px solid ' + color + ';" >' + button + '</spna>';
                        }
                        itemHtml += '</div>';
                        itemHtml += '</a>';
                        itemHtml += '</product-item>';
                    }
				  }
			  }
		  }
		itemHtml += boostPFSTemplate.productGridItemHtml;
      
      	// Custom class
      	itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, data.available ? '' : 'product-item--sold-out');
      
      	//Add Labels
        var itemDiscountLabel = '';
      	if (onSale) {
            var salePrice = ((data.compare_at_price_min - data.price_min)/data.compare_at_price_min) * 100;
          	itemDiscountLabel += '<div class="product-item__label-list label-list"><span class="label label--highlight">' + boostPFSThemeConfig.label.sale.replace('{{ savings }}', Math.ceil(salePrice)) + '%</span></div>';
        }
        itemHtml = itemHtml.replace(/{{itemDiscountLabel}}/g, itemDiscountLabel);
            
      	// Promo Tag labels
      	var promo_tags_list = '';
      	var itemPromoTagLabels = '';
        if (boostPFSAppConfig.general.hasOwnProperty('current_locale') && boostPFSAppConfig.general.current_locale == 'en') {
			promo_tags_list = boostPFSThemeConfig.custom.promo_tag_list;
        } else if (boostPFSAppConfig.general.hasOwnProperty('current_locale') && boostPFSAppConfig.general.current_locale == 'fr') {
          	promo_tags_list = boostPFSThemeConfig.custom.promo_tag_list_fr;
        }
        if (promo_tags_list !== '') {
			var custom_labels = promo_tags_list.split('\n');
			var block_tag_check = false;
            for (var i = 0; i < custom_labels.length; i++) {
				var custom_label = custom_labels[i];
              	var custom_label_item = custom_label.split('|');
              	var custom_label_tag = Utils.slugify(custom_label_item[0]);
              	var custom_label_title = custom_label_item[1];
                for (var j = 0; j < data.tags.length; j++) {
					var tag = Utils.slugify(data.tags[j]);
                    if (tag == custom_label_tag) {
						itemPromoTagLabels += '<div class="product-item__promo-label">' + custom_label_title + '</div>';
                      	block_tag_check = true;
                      	break;
                    }
                }
                if (block_tag_check){
                  break;
                }
            }
        }
      
      	itemHtml = itemHtml.replace(/{{itemPromoTagLabels}}/g, itemPromoTagLabels);

        // Tag labels
      	var tags_list = '';
      	var itemTagLabels = '';
        if (boostPFSAppConfig.general.hasOwnProperty('current_locale') && boostPFSAppConfig.general.current_locale == 'en') {
			tags_list = boostPFSThemeConfig.custom.tag_list;
        } else if (boostPFSAppConfig.general.hasOwnProperty('current_locale') && boostPFSAppConfig.general.current_locale == 'fr') {
          	tags_list = boostPFSThemeConfig.custom.tag_list_fr;
        }
        if (tags_list !== '') {
			var custom_labels = tags_list.split('\n');
			var block_tag_check = false;
            for (var i = 0; i < custom_labels.length; i++) {
				var custom_label = custom_labels[i];
              	var custom_label_item = custom_label.split('|');
              	var custom_label_tag = Utils.slugify(custom_label_item[0]);
              	var custom_label_title = custom_label_item[1];
                for (var j = 0; j < data.tags.length; j++) {
					var tag = Utils.slugify(data.tags[j]);
                    if (tag == custom_label_tag) {
						itemTagLabels += '<span class="label label--subdued">' + custom_label_title + '</span>';
                      	block_tag_check = true;
                      	break;
                    }
                }
            }
        }
        if (soldOut) {
          	itemTagLabels += '<span class="label label--subdued">' + boostPFSThemeConfig.label.sold_out + '</span>';
        }
      	itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, itemTagLabels);
      
      	// itemActiveSwapClass
      	var activeSwapImage = images.length > 1 && boostPFSThemeConfig.custom.show_secondary_image == true;
      	var itemImagesClass = activeSwapImage ? 'product-item__image-wrapper--multiple' : '';
		itemHtml = itemHtml.replace(/{{itemImagesClass}}/g, itemImagesClass);
      
      	// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data,index));
      
		// Add quick add button
		var itemQuickAddButton = '';
		if (data.variants.length == 0) {
      
      		itemQuickAddButton += '<form method="post" action="/cart/add" id="product_form_template__{{itemId}}_{{itemIndex}}" accept-charset="UTF-8" class="product-item__quick-form ' + boostPFSThemeConfig.custom.quick_view_visibility + '" enctype="multipart/form-data" is="product-form">';
          	itemQuickAddButton += '<input type="hidden" name="form_type" value="product">';
          	itemQuickAddButton += '<input type="hidden" name="utf8" value="✓">';
          itemQuickAddButton += '<input type="hidden" name="quantity" value="1">';
          itemQuickAddButton += '<input type="hidden" name="id" value="'+data.variants[0].id+'">';
          itemQuickAddButton += '<button is="loader-button" type="submit" class="button button--transparent button--light button--full  hidden-touch">';
          itemQuickAddButton += '<span class="loader-button__text">' + boostPFSThemeConfig.label.quick_view + '</span>';
          itemQuickAddButton += '<span class="loader-button__loader" hidden="">';
          itemQuickAddButton += '<div class="spinner">';
          itemQuickAddButton += '<svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg>';
          itemQuickAddButton += '</div>';
          itemQuickAddButton += '</span>';
			
		  } else {
			
			itemQuickAddButton += '<div class="product-item__quick-form ' + boostPFSThemeConfig.custom.quick_view_visibility + '">';
			itemQuickAddButton += '<button is="toggle-button" loader aria-controls="product-boost-pfs-filter-{{itemId}}-drawer-{{itemIndex}}" aria-expanded="false" class="button button--transparent button--light button--full hidden-touch hidden-phone">' + boostPFSThemeConfig.label.quick_view + '</button>';
			itemQuickAddButton += '<button is="toggle-button" aria-controls="product-boost-pfs-filter-{{itemId}}-drawer-{{itemIndex}}" aria-expanded="false" class="product-item__quick-buy-button hidden-no-touch hidden-phone">';
			itemQuickAddButton += '<span class="visually-hidden">' + boostPFSThemeConfig.label.quick_view + '</span>';
			itemQuickAddButton += '<svg focusable="false" width="22" height="21" class="icon icon--quick-buy   " fill="none" viewBox="0 0 22 21"><path d="M12 4H3L2 20H18C17.7517 16.0273 17.375 10 17.375 10" stroke="currentColor" stroke-width="2"></path><path d="M7 7V7C7 8.65685 8.34315 10 10 10V10C11.6569 10 13 8.65685 13 7V7" stroke="currentColor" stroke-width="2"></path><path d="M18 0V8M14 4H22" stroke="currentColor" stroke-width="2"></path></svg>';
			itemQuickAddButton += ' </button>';

			itemQuickAddButton += '<button is="toggle-button" aria-controls="product-boost-pfs-filter-{{itemId}}-popover-{{itemIndex}}" aria-expanded="false" class="product-item__quick-buy-button hidden-tablet-and-up">';
			itemQuickAddButton += '<span class="visually-hidden">' + boostPFSThemeConfig.label.quick_view + '</span>';
			itemQuickAddButton += '<svg focusable="false" width="22" height="21" class="icon icon--quick-buy   " fill="none" viewBox="0 0 22 21"><path d="M12 4H3L2 20H18C17.7517 16.0273 17.375 10 17.375 10" stroke="currentColor" stroke-width="2"></path><path d="M7 7V7C7 8.65685 8.34315 10 10 10V10C11.6569 10 13 8.65685 13 7V7" stroke="currentColor" stroke-width="2"></path><path d="M18 0V8M14 4H22" stroke="currentColor" stroke-width="2"></path></svg>';
			itemQuickAddButton += '</button>';
			itemQuickAddButton += '</div>';
		  }

		itemHtml = itemHtml.replace(/{{itemQuickAddButton}}/g, itemQuickAddButton);

      	// Add Quick Add
      	var itemQuickAdd = '';
      	if (data.variants.length == 0) {
          itemQuickAdd += '';
        } else {

          itemQuickAdd += '<quick-buy-popover initial-focus-selector="[type=\'text\']:first-of-type" id="product-boost-pfs-filter-{{itemId}}-popover-{{itemIndex}}" href="'+buildPreviewUrl(data,'view=quick-buy-popover')+'" class="popover hidden-tablet-and-up"></quick-buy-popover>';
          itemQuickAdd += '<quick-buy-drawer initial-focus-selector="[type=\'text\']:first-of-type" id="product-boost-pfs-filter-{{itemId}}-drawer-{{itemIndex}}" href="'+buildPreviewUrl(data,'view=quick-buy-drawer')+'" class="drawer drawer--large drawer--quick-buy hidden-phone"></quick-buy-drawer>';
        }
      	itemHtml = itemHtml.replace(/{{itemQuickAdd}}/g, itemQuickAdd);
      
      	// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}
      
      	// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
      
      	// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
      
      	// Add Color Swatches
		itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildProductOptionSwatches(data));
      
      	var itemColorCountHtml = '';
		var hideArrowsClass = '';
		var colors_translation = '';
		if (boostPFSAppConfig.general.hasOwnProperty('current_locale') && boostPFSAppConfig.general.current_locale == 'en') {
			colors_translation = 'colors';
        } else if (boostPFSAppConfig.general.hasOwnProperty('current_locale') && boostPFSAppConfig.general.current_locale == 'fr') {
			colors_translation = 'couleurs disponibles';
        }

      	if (typeof data.available_colors != 'undefined' && data.available_colors.length > 0) {
            var swatchArr = data.available_colors;
            if (typeof swatchArr != 'undefined' && swatchArr.length > 0) {
                if (swatchArr.length > 1) {
                    itemColorCountHtml = swatchArr.length + ' ' + colors_translation;
                }
				if (swatchArr.length >= 7) {
					hideArrowsClass = '';
				} else {
					hideArrowsClass = 'visually-hidden';
				}
            } else{
            	hideArrowsClass = 'visually-hidden';
            }
        }
      	itemHtml = itemHtml.replace(/{{itemColorCount}}/g, itemColorCountHtml);
		itemHtml = itemHtml.replace(/{{hideArrowsClass}}/g, hideArrowsClass);
      
      	// Add product title
      	var itemTitle = data.title;
        if (boostPFSAppConfig.general.current_locale == 'en') {
			itemTitle = Utils.getProductMetafield(data, 'product-fields', 'page_title_en') !== null ? Utils.getProductMetafield(data, 'product-fields', 'page_title_en') : itemTitle;
        } else if (boostPFSAppConfig.general.current_locale == 'fr') {
          	itemTitle = Utils.getProductMetafield(data, 'product-fields', 'page_title_fr') !== null ? Utils.getProductMetafield(data, 'product-fields', 'page_title_fr') : itemTitle;
        }
      
      	/* Swym integration */
     //    var itemWishlistHtml = '<button class="swym-button product_{{itemId}}" data-swaction="addToWishlist"  data-product-id="' + JSON.stringify(data.id) + '">';
     //  	itemWishlistHtml += '<svg focusable="false" width="19" height="19" viewBox="0 0 19 19" fill="none" role="presentation">';
     //  	itemWishlistHtml += '<path d="M17.9999 5.54722C17.9921 4.36852 17.5572 3.23908 16.7869 2.39702C16.0165 1.55495 14.9709 1.06604 13.8704 1.03335C12.77 1.00065 11.7006 1.42673 10.8878 2.22175C10.075 3.01678 9.58232 4.11863 9.51351 5.29506H9.48827C9.45072 4.5726 9.25271 3.87016 8.91068 3.24609C8.56865 2.62202 8.0925 2.09435 7.52174 1.7069C6.95099 1.31945 6.30212 1.08341 5.62906 1.0184C4.95599 0.95338 4.27814 1.06127 3.65184 1.33309C3.02553 1.6049 2.46885 2.03281 2.02803 2.58126C1.5872 3.12971 1.27498 3.78286 1.11727 4.48646C0.959568 5.19006 0.960937 5.92381 1.12128 6.62673C1.28162 7.32965 1.59629 7.98146 2.03916 8.52801L9.32846 18.5L17.0103 8.48598C17.6554 7.66317 18.0062 6.62151 17.9999 5.54722V5.54722Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>';
    	// itemWishlistHtml += '</svg>';
     //  	itemWishlistHtml += '</button>';
     //    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);
      
      	// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, itemTitle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, buildProductUrl(data));
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id );
      	itemHtml = itemHtml.replace(/{{itemIndex}}/g, index);
    }
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
  	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
    function buildProductUrl(data){
        let link = Utils.buildProductItemUrl(data);
        if(data.split_product && data.variant_id){
            link = link + '?variant='+data.variant_id;
        } else{
          if (data.firstVariant){
            link = link + '?variant='+data.firstVariant;
          }
        }
      	return link;
    }
	function buildPreviewUrl(data, preview){
		let link = Utils.buildProductItemUrl(data);
        if (link.includes('?')){
			link = link + '&' + preview;
        } else {
        	link = link + '?' + preview;
        }
        if(data.split_product && data.variant_id){
            link = link + '&variant='+data.variant_id;
        } else{
          if (data.firstVariant){
            link = link + '&variant='+data.firstVariant;
          }
        }
      	return link;
    }
  
  	function buildPromoMediaBG(background, title){
      	let img_html = '';
        if (background.includes('.mp4')){
			img_html = '<video playsinline autoplay muted loop alt="'+title.replace(/(<([^>]+)>)/gi, "")+'"><source src="'+background+'" type="video/mp4"></video>';
        } else {
        	img_html = '<img alt="'+title.replace(/(<([^>]+)>)/gi, "")+'" src="'+background+'">';
        }
      	return img_html;
    }
  
	function buildImages(data,index) {
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingTop = 100;

		var dataSrcSet = '',
			dataWidths = '',
			dataSizes = 'auto',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = images.length > 1 && boostPFSThemeConfig.custom.show_secondary_image == true;
        

		if (images.length > 0) {
			aspectRatio = images[0]['width'] / images[0]['height'];
			paddingTop = 1 / aspectRatio * 100;
		}
      
      	var grouped_stock_colors_array = [];
      	var available_color_variants_output = [];
        var colorOption = data.available_colors;
        if (typeof colorOption !== 'undefined') {
            for (var i = 0; i < colorOption.length; i++) {
                var color_inventory = 0;
                var colorStockLevels = '';
              	var option = colorOption[i];
                var available_variants = data.variants.filter(function(e) {
                    return e.available;
                });
                if (typeof available_variants[0] !== 'undefined') {
                    for (var j = 0; j < available_variants.length; j++) {
						var variant = available_variants[j];
                        if (variant.title.indexOf(option) !== -1) color_inventory += variant.inventory_quantity;
                    }
                  	colorStockLevels = Utils.slugify(option) + ':' + color_inventory;
                  	grouped_stock_colors_array.push(colorStockLevels);
                    
                }
            }
            // console.log(grouped_stock_colors_array);
            for (var i = 0; i < grouped_stock_colors_array.length; i++) {
              	var available_color_variants = '';
				var stock_color = grouped_stock_colors_array[i];
              	var color = stock_color.split(':');
              	var iColor = color[0];
              	var iStock = color[color.length - 1];
                if (iStock > 1) {
					available_color_variants = iColor
                }
              	available_color_variants_output.push(iColor);
            }
          
          	var product_image_size = (boostPFSThemeConfig.custom.product_image_size != 'natural') ? 'aspect-ratio--' + boostPFSThemeConfig.custom.product_image_size : '';
        	html += '<a href="{{itemUrl}}" data-product-id="{{itemId}}" class="product-item__aspect-ratio aspect-ratio ' + product_image_size + '" style="padding-bottom: ' + paddingTop + '%; --aspect-ratio: ' + aspectRatio + '">';
          
            for (var i = 0; i < available_color_variants_output.length; i++) {
                var color = available_color_variants_output[i];
              	var count = 0;
                var imageloading = 'lazy';

                if (data.activeColor && data.activeColor != ''){
                    html += '<div data-color="' + color + '" class="' + (color == Utils.slugify(data.activeColor) ? 'active selected' : 'visually-hidden') + '">';
                    imageloading = (color == Utils.slugify(data.activeColor) && index <= 3) ? 'eager' : 'lazy';
                  } 
                else {
                  html += '<div data-color="' + color + '" class="' + (i == 0 ? 'active selected' : 'visually-hidden') + '">';
                  imageloading = (i == 0 && index <= 3) ? 'eager' : 'lazy';
                  }
              
      //           if (Globals.queryParams.hasOwnProperty('pf_opt_color')) {
      //             	var colorArr = Globals.queryParams['pf_opt_color'];
      //             	var colorVariant = '';
      //               for (var j = 0; j < colorArr.length; j++) {
						// var selectedColor = colorArr[j];
      //                 	var variant = data.variants.filter(function(e) {
      //                     return e.option_color == selectedColor
      //                   });
      //                 	if (typeof variant[0] !== 'undefined') colorVariant = variant[0];
      //               }

      //             	if (colorVariant !== '') {
      //                 	html += '<div data-color="' + color + '" class="' + (color == Utils.slugify(colorVariant['originalColor']) ? 'active selected' : 'visually-hidden') + '">';
      //                   imageloading = (color == Utils.slugify(colorVariant['originalColor']) && index <= 3) ? 'eager' : 'lazy';
      //               } else {
      //                   if (data.hasOwnProperty('split_product')) {
      //                       var splitColor = data.splitColor;
      //                       html += '<div data-color="' + color + '" class="' + (color == Utils.slugify(splitColor) ? 'active selected' : 'visually-hidden') + '">';
      //                       imageloading = (color == Utils.slugify(splitColor) && index <= 3) ? 'eager' : 'lazy';
      //                   } else {
      //                   	html += '<div data-color="' + color + '" class="' + (i == 0 ? 'active selected' : 'visually-hidden') + '">';
      //                       imageloading = (i == 0 && index <= 3) ? 'eager' : 'lazy';
      //                   }
      //               }
      //           } else {
      //                   if (data.hasOwnProperty('split_product')) {
      //                       var splitColor = data.splitColor;
      //                       html += '<div data-color="' + color + '" class="' + (color == Utils.slugify(splitColor) ? 'active selected' : 'visually-hidden') + '">';
      //                       imageloading = (color == Utils.slugify(splitColor) && index <= 3) ? 'eager' : 'lazy';
      //                   } else {
      //                       html += '<div data-color="' + color + '" class="' + (i == 0 ? 'active selected' : 'visually-hidden') + '">';
      //                       imageloading = (i == 0 && index <= 3) ? 'eager' : 'lazy';
      //                   }
      //           }

                
              
                var imageInfo = data.hasOwnProperty('split_product') ? data.original_images : data.images_info;
                for (var j = 0; j < imageInfo.length; j++) {
                  	
					let thisColor = imageInfo[j]['alt'];
                  	let image = imageInfo[j]['src'];
                    let translation_images_en = Utils.getProductMetafield(data, 'translates', 'image');
                  	let translation_images_fr = Utils.getProductMetafield(data, 'translates', 'image_fr');
                  	
                  	if (boostPFSAppConfig.general.hasOwnProperty('current_locale') && boostPFSAppConfig.general.current_locale == 'fr' && translation_images_en && translation_images_fr) {
//                     	console.log(JSON.parse(translation_images_en), JSON.parse(translation_images_fr));
                      	translation_images_en = JSON.parse(translation_images_en);
                      	translation_images_fr = JSON.parse(translation_images_fr);
                        let image_name = image.split('/products/')[1].split('.')[0];
                      if (translation_images_en.includes(image_name)){
                        for (let index = 0; index < translation_images_en.length; index++) {
                         if(translation_images_en[index] === image_name && translation_images_fr[index]){
                         	// console.log(translation_images_fr[index]);
                           if (translation_images_fr[index]) {
							   image = translation_images_fr[index];                        
                           }
                           break;
                         }
                        }
                      }
                      	
                    }
					// console.log(data.images_info[j]);
                  	if (color == Utils.slugify(thisColor)) {
						count++;
                        if (count < 3) {
							var additionClass = 'product-item__primary-image';
                            if (count > 1) {
								additionClass = 'product-item__secondary-image image-hidden';
                                imageloading = 'lazy';
                            }
                          	html += '<img class="' + additionClass + '" loading="'+imageloading+'" ' +
                              			'sizes="(max-width: 740px) calc(50vw - 24px), calc((min(100vw - 80px, 1520px) - 0px) / 4 - 18px)" ' +
                              			'data-color="' + Utils.slugify(thisColor) + '" ' +
                              			'height="' + imageInfo[0].height + '" ' +
                                        'width="' + imageInfo[0].width + '" ' +
                                        'srcset="' + srcSet(image, imageInfo[0].width) + '" '+
                                        'alt="' + thisColor + '"  ' +
                              		'>';
                        }
                    }
                }
              	html += '</div>';
            }
          
          	html += '</a>';
			  html += '<div data-media-product-id="{{itemId}}" class="media-pool" style="display: none;">';
			  for (var i = 0; i < imageInfo.length; i++) {
                  let thisColor = imageInfo[i]['alt'];
                  let image = imageInfo[i]['src'];
                  let translation_images_en = Utils.getProductMetafield(data, 'translates', 'image');
                  let translation_images_fr = Utils.getProductMetafield(data, 'translates', 'image_fr');
                  

                  if (boostPFSAppConfig.general.hasOwnProperty('current_locale') && boostPFSAppConfig.general.current_locale == 'fr' && translation_images_en && translation_images_fr) {
                      	translation_images_en = JSON.parse(translation_images_en);
                      	translation_images_fr = JSON.parse(translation_images_fr);
                        let image_name = image.split('/products/')[1].split('.')[0];
                      if (translation_images_en.includes(image_name)){
                        for (let index = 0; index < translation_images_en.length; index++) {
                         if(translation_images_en[index] === image_name && translation_images_fr[index]){
                           if (translation_images_fr[index]) {
							   image = translation_images_fr[index];                        
                           }
                           break;
                         }
                        }
                      }
                      	
                    }
                  let src_set = srcSet(image, imageInfo[i].width);
                
				  html += '<img class="product-item__primary-image--carousel" loading="lazy"  ' + 
						'data-media-id="' + imageInfo[i].id + '" ' + 
						'sizes="(max-width: 740px) 52vw, calc(min(100vw - 80px, 1520px) /  - 21px)" ' + 
						'data-color="' + Utils.slugify(imageInfo[i].alt) + '" ' + 
						'height="' + imageInfo[i].height + '" ' +
						'width="' + imageInfo[i].width + '" ' +
						'srcset="' + src_set + '" '+
						'alt="' + imageInfo[i].alt + '"  ' +
					  '>';
			  }
				html += '</div>';
        } else {
            var product_image_size = (boostPFSThemeConfig.custom.product_image_size != 'natural') ? 'aspect-ratio--' + boostPFSThemeConfig.custom.product_image_size : '';
            html += '<a href="{{itemUrl}}" data-product-id="{{itemId}}" class="product-item__aspect-ratio aspect-ratio ' + product_image_size + '" style="padding-bottom: ' + paddingTop + '%; --aspect-ratio: ' + aspectRatio + '">';


            html += '<img class="product-item__primary-image" loading="'+imageloading+'" ' + 
                      'data-media-id="' + images[0].id + '" ' + 
                      'sizes="(max-width: 740px) calc(50vw - 24px), calc((min(100vw - 80px, 1520px) - 0px) / 4 - 18px)" ' + 
                      'data-color="' + images[0].alt + '" ' + 
                      'height="' + images[0].height + '" ' +
                      'width="' + images[0].width + '" ' +
                      'srcset="' + srcSet(images[0]['src'], images[0].width) + '" '+
                      'alt="' + images[0].alt + '"  ' +
                    '>';
            if (activeSwapImage) {
                html += '<img class="product-item__secondary-image pending" loading="lazy" ' + 
                          'data-media-id="' + images[1].id + '" ' + 
                          'sizes="(max-width: 740px) calc(50vw - 24px), calc((min(100vw - 80px, 1520px) - 0px) / 4 - 18px)" ' + 
                          'data-color="' + images[1].alt + '" ' + 
                          'height="' + images[1].height + '" ' +
                          'width="' + images[1].width + '" ' +
                          'srcset="' + srcSet(images[1]['src'], images[1].width) + '" '+
                          'alt="' + images[1].alt + '"  ' +
                        '>';
            }
            html += '</a>';

            html += '<div data-media-product-id="{{itemId}}" class="media-pool" style="display: none;">';
            for (var i = 0; i < images.length; i++) {
                html += '<img class="product-item__primary-image" loading="lazy" ' + 
                      'data-media-id="' + images[i].id + '" ' + 
                      'sizes="(max-width: 740px) calc(50vw - 24px), calc((min(100vw - 80px, 1520px) - 0px) / 4 - 18px)" ' + 
                      'data-color="' + Utils.slugify(images[i].alt) + '" ' + 
                      'height="' + images[i].height + '" ' +
                      'width="' + images[i].width + '" ' +
                      'srcset="' + srcSet(images[i]['src'], images[i].width, 'media') + '" '+
                      'alt="' + images[i].alt + '"  ' +
                    '>';
            }
      		html += '</div>';
        }

		return html;
	}
    function srcSet(image_src, image_width, media) {
		var srcSet = '';
      	var media = media || '';
  		if (image_src && image_width) {
            if (image_width > 200 && media == 'media') srcSet += ' ' + Utils.optimizeImage(image_src, '200x') + ' 200w, ';
            if (image_width > 300 && media == 'media') srcSet += ' ' + Utils.optimizeImage(image_src, '300x') + ' 300w, ';
            if (image_width > 400 && media == 'media') srcSet += ' ' + Utils.optimizeImage(image_src, '540x') + ' 400w, ';
            if (image_width > 500 && media == '') srcSet += ' ' + Utils.optimizeImage(image_src, '720x') + ' 500w, ';
            if (image_width > 600 && media == '') srcSet += ' ' + Utils.optimizeImage(image_src, '900x') + ' 600w, ';
            if (image_width > 700 && media == '') srcSet += ' ' + Utils.optimizeImage(image_src, '1080x') + ' 700w, ';
            if (image_width > 800 && media == '') srcSet += ' ' + Utils.optimizeImage(image_src, '1296x') + ' 800w, ';
            if (image_width > 900 && media == '') srcSet += ' ' + Utils.optimizeImage(image_src, '1512x') + ' 900w, ';
            if (image_width > 1000 && media == '') srcSet += ' ' + Utils.optimizeImage(image_src, '1728x') + ' 1000w, ';
            if (image_width > 1100 && media == '') srcSet += ' ' + Utils.optimizeImage(image_src, '1950x') + ' 1100w, ';
            if (image_width > 1200 && media == '') srcSet += ' ' + Utils.optimizeImage(image_src, '2100x') + ' 1200w, ';
        }
		return srcSet;
	} 
  
  	function bgset(image, media) {
		var bgset = '';
      	var media = media || '';
		if (image) {
			var aspect_ratio = image.width / image.height;

			if (image.width > 200 && media == 'media') bgset += ' ' + Utils.optimizeImage(image.src, '200x') + ' 200w, ';
			if (image.width > 300 && media == 'media') bgset += ' ' + Utils.optimizeImage(image.src, '300x') + ' 300w, ';
			if (image.width > 400 && media == 'media') bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 400w, ';
			if (image.width > 500 && media == '') bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 500w, ';
			if (image.width > 600 && media == '') bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 600w, ';
			if (image.width > 700 && media == '') bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 700w, ';
			if (image.width > 800 && media == '') bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 800w, ';
			if (image.width > 900 && media == '') bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 900w, ';
			if (image.width > 1000 && media == '') bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1000w, ';
			if (image.width > 1100 && media == '') bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1100w, ';
			if (image.width > 1200 && media == '') bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 1200w, ';
		}
		return bgset;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_vendor == true) {
			html = boostPFSTemplate.vendorHtml.replace('{{itemVendorUrl}}', Utils.buildProductItemVendorUrl(data.vendor));
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
      	var priceMin = boostPFSThemeConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, window.themeVariables.settings.moneyWithCurrencyFormat) : Utils.formatMoney(data.price_min, window.themeVariables.settings.moneyFormat);
        var priceMax = boostPFSThemeConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_max, window.themeVariables.settings.moneyWithCurrencyFormat) : Utils.formatMoney(data.price_max, window.themeVariables.settings.moneyFormat);
      	var comparePriceMin = boostPFSThemeConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, window.themeVariables.settings.moneyWithCurrencyFormat) : Utils.formatMoney(data.compare_at_price_min, window.themeVariables.settings.moneyFormat);
      	if(!Utils.getParam('pf_opt_color') && boostPFSThemeConfig.custom.hide_sale_variants){
            html += '<span class="price">';
            html += priceMax;
            html += '</span>';
        } else {
           if (onSale) {
            if (priceVaries) {
              html += '<span class="price price--highlight">';
              html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
              html += boostPFSThemeConfig.label.from.replace('{{ price_min }}', priceMin);
              html += '</span>';
  
              html += '<span class="price price--compare">';
              html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
              html += comparePriceMin;
              html += '</span>';
            } else {
              html += '<span class="price price--highlight">';
              html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
              html += priceMin;
              html += '</span>';
  
              html += '<span class="price price--compare">';
              html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
              html += comparePriceMin;
              html += '</span>';
            }
          } else {
            if (priceVaries) {
              html += '<span class="price">';
              html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
              html += boostPFSThemeConfig.label.from.replace('{{ price_min }}', priceMin);
              html += '</span>';
            } else {
              html += '<span class="price">';
              html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
              html += priceMin;
              html += '</span>';
            }
          }
        }
        
		return html;
	}
  
	// Build Color Swatches
	function buildProductOptionSwatches(data) {
        var swatchesProductOptionHtml = '';
        if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0) {
            var swatchArr = data.available_colors;
            if (typeof swatchArr != 'undefined' && swatchArr.length > 0) {
                if (swatchArr.length > 1) {
                    var colors = swatchArr;
                    swatchesProductOptionHtml += '<div class="product-item-meta__swatch-list new color-swatch-list color-swatch-list--mini hide-scrollbar">';
                    for (var i = 0; i < colors.length; i++) {
                        var color = colors[i];
                        var variant = data.variants.find(function(e){ return e.originalColor == color});
                        if (typeof variant != 'undefined') {
                            var image = boostPFSThemeConfig.custom.color_swatch_config.filter(function(e){
                                var text = e.split(':');
                                var first = text[0].replace('\n', '');
                                return first == color;
                            });
                            var backgroundColor = '';
                            var cssColor = '';
                            if (typeof image != 'undefined' && image.length > 0) {
                                backgroundColor = image[0].split(':');
                                if (backgroundColor.length == 3){
                                  backgroundColor = backgroundColor[2]
                                } else{
                                  backgroundColor = backgroundColor[1]
                                }
                                if (backgroundColor.indexOf('#') > -1) {
                                  	cssColor = 'background-color: ' + backgroundColor;
                                } else {
                                    var url = boostPFSAppConfig.general.file_url.split('?')[0] + backgroundColor;
                                    cssColor = 'background-image: url(' + Utils.optimizeImage(url, '72x72') + ')';
                                }
                            }
                          
                          	var checked = '';
                            if (data.activeColor && data.activeColor != ''){
                              if (variant.originalColor == data.activeColor) {
                                  checked = 'checked="checked"';
                                }
                            } 
                            else {
                              if (i == 0) {
                                checked = 'checked="checked"';
                              }
                            }
                          	var saleAttr = Number(variant.compare_at_price || '0') > Number(variant.price) ? 'data-sale="true"' : '';
                          	var stockAttr = variant.available ? 'data-stock="in-stock"' : '';
                          	swatchesProductOptionHtml += '<div class="color-swatch " ' + saleAttr + ' ' + stockAttr + '>';
                            swatchesProductOptionHtml += '<input class="color-swatch__radio visually-hidden" type="radio" name="template--14255255027777__main--{{itemId}}" data-swatch-product-id="{{itemId}}" data-color-handle="' + Utils.slugify(color) + '" id="template--14255255027777__main--{{itemId}}-' + (i+1) + '" value="' + color + '" data-variant-id="' + variant.id + '" ' + checked + '>';
                            swatchesProductOptionHtml += '<label class="color-swatch__item" for="template--14255255027777__main--{{itemId}}-' + (i+1) + '" data-product-id="{{itemId}}" data-color="' + Utils.slugify(color) + '" style="background-color:' + Utils.slugify(color) +'; ' + cssColor + '">';
                            swatchesProductOptionHtml += '<span class="visually-hidden">' + color + '</span>';
                            swatchesProductOptionHtml += '</label>';
                            swatchesProductOptionHtml += '</div>';
                        }
                    }
                    swatchesProductOptionHtml += '</div>';
                }
            }
        }
        return swatchesProductOptionHtml;
	}

	// Build Color Swatches
	function eventColorSwatches(event) {
		jQ('.boost-pfs-filter-item-swatch li span').each(function() {
			var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
			if (event == 'hover') {
				jQ(this).hover(function() {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				});
			}
			if (event == 'click') {
				jQ(this).click(function() {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				});
			}
			jQ(this).focus(function() {
				if (jQ('body').hasClass('boost-pfs-ada')) {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				}
			});
		});
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		return html;
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var activeClass = '';
					if (paramSort == k) {
						activeClass = ' aria-current ';
					}
                    sortingItemsHtml += '<label class="popover__choice-item">';
                    sortingItemsHtml += '<span class="popover__choice-label" ' + activeClass + ' data-sort="' + k + '">' + sortingArr[k] + '</span>';
                    sortingItemsHtml += '</label>'
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// ProductSorting.prototype.render = function() {
	// 	jQ(Selector.topSorting).html(this.compileTemplate());
      
	// 	var labelSort = '';
	// 	var paramSort = Globals.queryParams.sort || '';
	// 	var sortingList = Utils.getSortingList();
	// 	if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
	// 		labelSort = sortingList[paramSort];
	// 	} else {
	// 		labelSort = Labels.sorting_heading;
	// 	}

	// 	jQ('#sort-by-selected-value').text(labelSort);
	// }

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var _this = this;
		jQ(Selector.topSorting + ' .popover__choice-item .popover__choice-label').click(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
	};
  

	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		// Intergrate Review Shopify
		if (window.SPR &&
			typeof window.SPR.initDomEls == 'function' &&
			typeof window.SPR.loadBadges == 'function' &&
			boostPFSThemeConfig.custom.show_product_review) {
			window.SPR.initDomEls();
			window.SPR.loadBadges();
		}
      
      	const productItemLinks = document.querySelectorAll('.product-item__image-wrapper > a');

        productItemLinks.forEach((el)=>{

          // toggle class on hover to show secondary image

          el.addEventListener("mouseenter", ( event ) => {
            event.target.lastChild.classList.remove('pending');
            event.target.firstChild.classList.add('pending');
          });

          // and restore primary image on mouse leave

          el.addEventListener("mouseleave", ( event ) => {
            event.target.lastChild.classList.add('pending');
            event.target.firstChild.classList.remove('pending');
          });

        });
      
      	/** Start Swym integration **/
        window.SwymCallbacks = window.SwymCallbacks || [];
        window.SwymCallbacks.push(function(swat) { 
            // Wrap with callback for loading without additional checks
            var products = [];
            data.forEach(function(product) {
                var image_src = Utils.getFeaturedImage(product.images_info);
                var productCopy = product;
                productCopy.featured_image = image_src;
                productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
                productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
                products.push(productCopy);
            });
            swat.mapShopifyProducts(products); // Product mapped data to swym layer
            swat.initializeActionButtons('.boost-pfs-filter-products'); // Buttons can now be initialized
        });
        /** End Swym integration **/
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		if (boostPFSAppConfig.general.current_locale == 'en') {
			var totalProduct = 'Showing ' + data.total_product + ' ' + boostPFSThemeConfig.label.items_with_count_other;
				if (data.total_product == 1) {
					totalProduct = 'Showing ' + data.total_product + ' ' + boostPFSThemeConfig.label.items_with_count_one;
				}
		} else if (boostPFSAppConfig.general.current_locale == 'fr') {
			var totalProduct = 'Affichage de ' + data.total_product + ' produits';
			if (data.total_product == 1) {
				totalProduct = 'Affichage de ' + data.total_product + ' produit';
			}
		}

		if (data.total_product == 0) {
            jQ('.product-facet__meta-bar').remove();
             jQ('.boost-pfs-filter-products').addClass('no-results');
			jQ(".boost-pfs-filter-default-toolbar-inner").addClass('boost-pfs-filter-toolbar-product-0');
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);

		jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

		jQ('a.arrow-right').click(function() {
		  $('.product-item-meta__swatch-list ').scrollLeft(300);
		});

        // shuffle products
        if (boostPFSThemeConfig.custom.shuffle_products ){
         let s_sort = Utils.getParam('sort');
          if(!s_sort){
            if (boostPFSThemeConfig.custom.tiles == null){
              $(".boost-pfs-filter-products product-item:not(.shuffled)").each(function() {
                $(this).addClass('shuffled').css('order',getRandomIntInclusive((Globals.queryParams.page - 1)*24,Globals.queryParams.page*24));
              });
            }          
          } 
        }
	};

    // 29 APR 2025
    // added as per Boost instructions to hide products tagged with "hide-usa"
    FilterApi.beforeCall = function () { 
      if (Shopify.country == 'CA') { 
        Globals.queryParams.h_options = ["hide-usa"]; 
      } 

      // Add this code to support FrontAPI
      if (Shopify && Globals) {
        Globals.queryParams.currency = Shopify.currency.active;
        Globals.queryParams.currency_rate = Shopify.currency.rate;
        Globals.queryParams.country = Shopify.country;
        Globals.queryParams.return_all_currency_fields = false;
      }
    };
  
  	FilterTree.prototype.afterRender = function() {
      	var selectedItems = this.refineBy.refineByItems;
      	if (boostPFSAppConfig.general.hasOwnProperty('current_locale') && boostPFSAppConfig.general.current_locale == 'fr') {
        	if (boostPFSAppConfig.filter.hasOwnProperty('translations')) {
              selectedItems.forEach(element => {
				let option_label = element.$element.find('.refine-by-value').text();
                if (boostPFSAppConfig.filter.translations[option_label]){
              	element.$element.find('.refine-by-value').text(boostPFSAppConfig.filter.translations[option_label]);
              }
              });
            }
        }
      	if (selectedItems.length > 0) {
            jQ('.product-facet__active-count').html(selectedItems.length).removeClass('hidden');
            jQ('a.boost-pfs-filter-clear-all-custom').show();
        } else {
            jQ('.product-facet__active-count').addClass('hidden');;
            jQ('a.boost-pfs-filter-clear-all-custom').hide();
        }
      
      	jQ('a.boost-pfs-filter-clear-all-custom').off('click').on('click', function(e){
            e.preventDefault();
            jQ('.boost-pfs-filter-tree .boost-pfs-filter-clear-all').trigger('click');
        });
	};
  
  	FilterOption.prototype.afterRender = function () {
      	if (boostPFSAppConfig.general.hasOwnProperty('current_locale') && boostPFSAppConfig.general.current_locale == 'fr') {
        	if (boostPFSAppConfig.filter.hasOwnProperty('translations')) {
              let option_label = decodeHtml(this.label);
              if (boostPFSAppConfig.filter.translations[option_label]){
              	this.$filterOptionTitleElement.find('.boost-pfs-filter-option-title-text').text(boostPFSAppConfig.filter.translations[option_label]);
              }
            }
        }
      	var html = '<svg focusable="false" width="12" height="8" class="icon icon--chevron icon--inline  " viewBox="0 0 12 8"><path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path></svg>';
      	if (this.$filterOptionTitleElement.find('svg').length < 1) {
          	this.$filterOptionTitleElement.append(html);
        }
    }

    function decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    FilterOptionItem.prototype.afterRender = function() {
      	if (this.parent.filterOptionId == "pf_opt_color") {
          	this.$element.attr('data-title', this.value);
        }
      	if (boostPFSAppConfig.general.hasOwnProperty('current_locale') && boostPFSAppConfig.general.current_locale == 'fr') {
        	if (boostPFSAppConfig.filter.hasOwnProperty('translations')) {
              let option_label = decodeHtml(this.label);
              if (boostPFSAppConfig.filter.translations[option_label]){
                this.label = boostPFSAppConfig.filter.translations[option_label];
                if (this.$itemElement) {
                  this.$itemElement.find('.boost-pfs-filter-option-value').text(boostPFSAppConfig.filter.translations[option_label]);
                } else {
                  this.$element.find('.boost-pfs-filter-option-value').text(boostPFSAppConfig.filter.translations[option_label]);
                }
              }
            }
        }
    }


    ProductPaginationLoadMore.prototype.getTemplate = function(tempType) {
		switch(tempType) {
			case 'total':
				return `
					<div class="{{class.productLoadMore}}-total">{{progressLabel}}</div>
				`.trim();
			default:
				return `
					<div class="{{class.productLoadMore}}-button-container">
						<button aria-label="{{label.loadMore}}" class="{{class.productLoadMore}}-button">{{label.loadMore}}</button>
					</div>
					{{loadMoreProgress}}
					<div class="{{class.productLoadMore}}-loading" style="display: none;">
						<div class="{{class.productLoadMore}}-icon"></div>
					</div>
				`.trim();
		}
    }
    
    ProductPaginationLoadMore.prototype.compileTotalTemplate = function() {
		/**
		 * If enable the Load previous feature and the evnet type is page:
		 * => Get the next loading page is from session storage OR get the next loading page from query param
		 */
		if (!Globals.queryParams.page || isNaN(Globals.queryParams.page)) {
			Globals.queryParams.page = 1;
		}
		if (!Globals.queryParams.limit || isNaN(Globals.queryParams.limit)) {
			Globals.queryParams.limit = 20;
		}
		if (Utils.isLoadPreviousPagePaginationType() && this.parent.eventType == 'page') {
			this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage));
		} else {
			this.nextPage = Globals.queryParams.page;
		}
		// Set from index
		var fromProduct = (this.nextPage - 1) * Globals.queryParams.limit + 1;
      	var numberOfShowingProducts = jQ(Selector.products + ' > *:not(script):not(style):not(.grid-tile)').length;
		if (numberOfShowingProducts) {
			fromProduct -= numberOfShowingProducts - Globals.queryParams.limit;
		}
		this.fromProduct = fromProduct;

		// Set to index
		var product_index = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		var toProduct = product_index + this.data.products.length - 1;
		this.toProduct = toProduct;

		return this.getTemplate('total')
			.replace(/{{progressLabel}}/g, Labels.loadMoreTotal)
			.replace(/{{ from }}/g, this.fromProduct)
			.replace(/{{ to }}/g, this.toProduct)
			.replace(/{{ total }}/g, this.totalProduct)
			.replace(/{{class.productLoadMore}}/g, Class.productLoadMore)
	}
})();